import { Controller } from 'stimulus'

// Minimal disclosure: a trigger shows/hides one panel.
// <div data-controller="disclosure">
//   <button data-action="disclosure#toggle" data-target="disclosure.trigger" aria-expanded="false">…</button>
//   <div data-target="disclosure.panel" class="hidden">…</div>
// </div>
export default class extends Controller {
  static targets = ['panel', 'trigger']

  toggle() {
    const hidden = this.panelTarget.classList.toggle('hidden')
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute('aria-expanded', (!hidden).toString())
    }
  }
}
